<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="pa-0 ma-0">
    <!--
    <v-row>
      <v-col cols="12">
        <v-btn v-print="printObj"><v-icon>mdi-printer</v-icon> Print Page</v-btn>
      </v-col>
    </v-row>
    -->
    <v-row dense>
      <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
        <v-row class="px-4 pt-4">
          <v-col md="3" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-autocomplete
              prepend-icon="mdi-account"
              v-model="clientid"
              item-text="text"
              label="Filter by a client ..."
              @change="getList()"
              :items="clients"
            />
          </v-col>
          <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-select
              prepend-icon="mdi-text-box-multiple-outline"
              v-model="invoicetype"
              item-text="text"
              @change="getList()"
              label="Filter by invoice type"
              :items="invoices"
            />
          </v-col>
          <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-select
              prepend-icon="mdi-file-table-box-multiple"
              v-model="ordertype"
              item-text="text"
              @change="getList()"
              label="Please select platform"
              :items="platforms"
            />
          </v-col>

          <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-text-field
              prepend-icon="mdi-pencil"
              v-model="notes"
              label="Filter by notes"
            />
          </v-col>
          <v-col md="3" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-dialog ref="dialog" v-model="modal" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Date range"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.dialog.save(date);
                    getList();
                  "
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :footer-props="{
                'items-per-page-options': [25, 50, 100, 150, -1]
              }"
              :items-per-page="50"
              id="printMe"
              :search="notes"
              :loading="isloading"
              :loading-text="loadingtext"
              :headers="headers"
              :items="items"
              :pageCount="numberOfPages"
              :server-items-length="totalItems"
              :options.sync="options"
              ref="tbl"
            >

              <template v-slot:item.paid="{ item }">
                <v-chip :color="getPaidColor(item.paid)" dark>
                  {{ getPaidLabel(item.paid) }}</v-chip
                >
              </template>

              <template v-slot:item.ready="{ item }">
                <v-btn :color="getReadyColor(item.ready)" dark icon><v-icon>{{ getReadyLabel(item.ready) }}</v-icon></v-btn>
              </template>

              <template v-slot:item.grandtotal="{ item }">
                <v-chip  title="Invoice Grand Total">
                  <strong>${{ item.grandtotal }}</strong>
                </v-chip>
                <v-chip class="ml-1" :color="getColor(item.profit)" title="Invoice Profit" dark v-if="$store.state.loggedUser.isadmin == 1">
                  <strong>${{ item.profit }}</strong>
                </v-chip>
              </template>


              <template v-slot:item.notes="{ item }">
               <div class="mybox">{{item.notes}}</div>
              </template>



              <template v-slot:item.action="{ item }">
                <div
                  class="d-flex align-center align-content-center justify-center"
                >
                  <v-btn
                    class="actionbtns mx-1"
                    primary
                    small
                    dark
                    @click="print(item)"
                    color="green"
                    center
                  >
                    <v-icon medium>
                      mdi-printer
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="actionbtns mx-1"
                    primary
                    dark
                    small
                    color="orange"
                    center
                    @click="editItem(item)"
                  >
                    <v-icon medium>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="actionbtns mx-1"
                    small
                    color="red"
                    warning
                    dark
                    @click="deleteItem(item)"
                  >
                    <v-icon medium>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </div>
              </template>

              <template slot="footer">
                <div class="d-flex justify-space-around align-center my-4">
                  <div>Total invoices: <strong>${{ totalrows }}</strong></div>
                  <div v-if="$store.state.loggedUser.isadmin == 1"> Total profit: <strong>${{ totalprofit }}</strong></div>
                </div>
              </template>


            </v-data-table>
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
  </v-container>
</template>

<script>
import { __HTTP, FormHeader, __HAS_PERM } from "@/utils/utils";

export default {
  computed: {
    dateRangeText() {
      //this.getList();
      return this.dates.join(" ~ ");
    },
    totalprofit() {
      var total = 0;
      this.items.forEach(e => {
        //console.log(e);
        total += parseInt(e.profit.replace(",",""));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    totalrows() {
      var total = 0;
      this.items.forEach(e => {
        total += parseInt(e.grandtotal.replace(",",""));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
  },
  components: {},
  watch: {
    options: {
      handler() {
        this.getList();
      }
    }
  },
  methods: {
    getPaidColor(data) {
      if (data === "1") return "green";
      else return "grey";
    },
    getPaidLabel(data) {
      if (data === "1") return "Yes";
      else return "No";
    },
    getReadyColor(data) {
      if (data === "1") return "green";
      else return "red";
    },
    getReadyLabel(data) {
      if (data === "1") return "mdi-check";
      else return "mdi-close-circle-outline";
    },
    getColor(profit) {
      if (parseFloat(profit) === 0) return "orange"
      else if (parseFloat(profit) > 0) return "green"
      else return "red";
    },
    editItem(i) {
      this.$router.push({
        path: "/sales-tajmeea",
        query: { do: "edit", id: i.id }
      });
    },
    getList() {
      console.log("GetListTriggered");
      this.isloading = true;
      this.items = [];
       const { page, itemsPerPage } = this.options;
      let pageNumber = page - 1;
      //console.log(JSON.stringify({keyword: this.search,clientid: this.clientid,ordertype: this.ordertype,date: this.dates}));
      __HTTP(
        "?do=list&type=sales",
        JSON.stringify({
          pageNumber: pageNumber,
          itemsPerPage: itemsPerPage,
          isadmin: this.$store.state.loggedUser.isadmin,
          showall: this.$store.state.loggedUser.showall,
          id: this.$store.state.loggedUser.id,
          keyword: this.search,
          clientid: this.clientid,
          ordertype: this.ordertype,
          invoicetype: this.invoicetype,
          date: this.dates
        }),
        FormHeader,
        res => {
          //console.log(res);
          this.numberOfPages = res.numOfPages;
          this.totalItems = parseInt(res.items);
          this.isloading = false;
          this.items = res.data;
        }
      );
    },
    getClients() {
      this.loading = true;
      __HTTP("?do=getclients", "", FormHeader, res => {
        this.getPlatforms();
        this.isloading = false;
        this.clients = res;
      });
    },
    print(item) {
      this.$router.push({ path: "/print", query: { id: item.id } });
    },
    getPlatforms() {
      __HTTP("?do=getplatforms", "", FormHeader, res => {
        //this.isloading = false
        this.platforms = res;
      });
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      let c = confirm("Are you sure to remove this record ?");
      if (c) {
        __HAS_PERM(32, this.$store.state.loggedUser.id, () => {
          __HTTP("?do=delete", { type: "sales", id: item.id }, null, () => {
            this.items.splice(index, 1);
          });
        });
      }
    }
  },
  created() {
    this.$store.state.title = "Sales";
    this.getClients();
    //this.getList();
  },
  data: () => ({
    valid: true,
    search: "",
    options: {},
    platforms: [],
    numberOfPages:0,
    clientid: null,
    totalItems: 0,
    isloading: false,
    loadingtext: "Please wait while loading data ...",
    dialog: false,

    toBeEdit: null,
    headers: [
      {
        sortable: true,
        text: "#",
        value: "id"
      },
      {
        sortable: true,
        text: "Client name",
        value: "clientname"
      },
      {
        sortable: true,
        text: "Invoice type",
        value: "invoicetype"
      },
      {
        sortable: true,
        text: "Grand total",
        value: "grandtotal"
      },
      {
        sortable: true,
        text: "Platform",
        value: "ordertype"
      },
      {
        sortable: true,
        text: "Paid ?",
        value: "paid"
      },
      {
        sortable: true,
        text: "Ready",
        value: "ready"
      },
      {
        sortable: true,
        text: "Notes",
        value: "notes"
      },
      {
        sortable: true,
        text: "Added by",
        value: "addby"
      },
      {
        sortable: true,
        text: "Date",
        value: "adddate"
      },
      { text: "Tools", value: "action", sortable: false }
    ],
    clients: [],
    items: [],
    notes:"",
    invoicetype: [],
    invoices: [
      { text: "Custom PC", value: "0" },
      { text: "Parts", value: "1" }
    ],
    ordertype: [],
    //today: new Date(),
    dates: [],
    modal: false,
    printObj: {
      id: "printMe",
      popTitle: "Printing Page",
      extraCss: "https://tajmeea.esite-lab.com/print.css?v=1",
      extraHead: '<meta http-equiv="Content-Language"content="ar-iq"/>'
    }
  }),
  mounted() {
    this.dates = [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1 + 1)
        .toISOString()
        .substr(0, 10),
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0 + 1)
        .toISOString()
        .substr(0, 10)
    ];
  }
};
</script>

<style>
.mybox { max-width: 200px;height: 100%; text-align: right;}
</style>
